import { PrismicNextLink } from "@prismicio/next";

import { linkResolver } from "@up/data";

import type { ComponentProps } from "react";

export const UPLink = function UPLink(
  props: ComponentProps<typeof PrismicNextLink>,
) {
  return <PrismicNextLink linkResolver={linkResolver} {...props} />;
};
